export default {
  emptyTitle: 'No conversations yet',
  emptySubtitle: 'Your existing conversations will be here.',
  offHoursEmptyTitle: 'Please leave a message',
  offHoursEmptySubtitle: 'We will get back to you as soon as we are online!',
  ended: 'Ended',
  previewAttachmentReceived: 'You received an attachment',
  previewAttachmentSent: 'You sent an attachment',
};
